import qs from 'qs';
import log from '../log';
import VersionVal from '../../package.json';
import { getLanguage } from '../../src/language/i18n';
import { NetConnected } from '../../App';
import { Str_NetworkConnectFail } from '../../src/language/string_res';
import time from '../time';
import { Platform } from 'react-native';

export const defaultHeader = () => {
    return {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'KK-Version': Platform.OS + '.' + VersionVal.version,
        lang: getLanguage(),
    };
};

export interface RequestConfig extends Omit<RequestInit, 'body'> {
    method?: 'GET' | 'POST' | 'DELETE' | 'PUT';
    params?: object;
    body?: object;
}

const defaultConfig: RequestConfig = {
    method: 'GET',
    keepalive: true,
};

export type ResponseContext<D, C = any> = {
    code: number;
    data?: D;
    config?: C;
    message?: string;
    msg?: string;
    err?: any;
};

export const request = <D, C>(
    url: string,
    config: RequestConfig,
): Promise<ResponseContext<D, C>> => {
    const requestConfig: RequestConfig = Object.assign(
        {},
        defaultConfig,
        config,
    );
    const requestInit: RequestInit = {};
    requestInit.headers = defaultHeader();
    requestInit.method = requestConfig.method || 'GET';
    if (requestConfig.headers) {
        requestInit.headers = Object.assign(
            {},
            defaultHeader(),
            requestConfig.headers,
        );
    }

    if (requestConfig.params) {
        // log.info('>>> fetch parmas: ', requestConfig.params);
        url += '?' + qs.stringify(requestConfig.params);
    }

    if (requestConfig.method === 'POST') {
        log.info('>>> fetch post body: ', requestConfig.body);
        requestInit.body = JSON.stringify(requestConfig.body || {});
    }

    if (log.getLevel() <= log.DEBUG) {
        log.debug('>>> start fetch: ' + url, '\n', requestInit);
    } else {
        log.info('>>> start fetch: ' + url);
    }
    const watch = time.watch();
    if (NetConnected.isConnected === false) {
        return new Promise((resolve) => {
            resolve({ code: -1, msg: Str_NetworkConnectFail, })
        })
    }

    console.log('>>> Call: ', url, JSON.stringify(requestInit));
    return fetch(url, requestInit)
        .then((res) => {
            log.info('>>> Call res', JSON.stringify(res));
            if (res.status === 200) {
                return res.json()
            }
            if (res.status === 408) {
                return { code: -1, msg: Str_NetworkConnectFail, message: Str_NetworkConnectFail }
            }
            return { code: -1, msg: Str_NetworkConnectFail, message: Str_NetworkConnectFail }
        })
        .then((json) => {
            if (log.getLevel() <= log.DEBUG) {
                log.debug(
                    'KKDB>>> end fetch[' + `${watch()}ms`, json.code + ']: ' + url,
                    '\n>>> response data: ',
                    // json,
                );
            } else {
                // log.info('>>> end fetch[' + json.code + ']: ' + url);
            }
            return json;
        })
        .catch((err) => ({ code: -1, message: err.message, err }));
};

// export const getJson = <D, C = any>(url: string, config?: RequestConfig) =>
//     request<D, C>(url, { ...config, method: 'GET' });

export const postJson = <D, C = any>(url: string, config?: RequestConfig) => request<D, C>(url, { ...config, method: 'POST' });
